/**
 * Конфигурация платежной системы
 * Значения берутся из .env файла (REACT_APP_ префикс обязателен для CRA)
 *
 * В .env добавить:
 * REACT_APP_PAYMENT_DEMO_MODE=false
 * REACT_APP_PAYMENT_DEMO_DAYS=14
 * REACT_APP_PAYMENT_DEMO_IS_PAYED=false
 * REACT_APP_PAYMENT_AMOUNT=2000
 */

export const PAYMENT_CONFIG = {
	/** Демо-режим для тестирования UI без бэкенда */
	DEMO_MODE: process.env.REACT_APP_PAYMENT_DEMO_MODE === "true",

	/** Количество дней для демо-режима */
	DEMO_DAYS: parseInt(process.env.REACT_APP_PAYMENT_DEMO_DAYS || "14", 10),

	/** Статус оплаты для демо-режима */
	DEMO_IS_PAYED: process.env.REACT_APP_PAYMENT_DEMO_IS_PAYED === "true",

	/**
	 * Сумма платежа в рублях — fallback.
	 * Основная цена приходит с бэка в school_price (см. getPaymentAmount).
	 * Это значение используется, только если бэк не вернул school_price
	 * (например, сборка Белбека).
	 */
	AMOUNT: parseInt(process.env.REACT_APP_PAYMENT_AMOUNT || "2000", 10),
};

